import React from "react";
import { PDFExport } from "@progress/kendo-react-pdf";
import PropTypes from 'prop-types';
import bg from "../../assets/images/HeaderDocument.jpg";
import sign_inno from "../../assets/images/sign_inno.png"
import "./base.css";

const HRM_040 = ({ pdfExportComponent, data , company, company2}) => {
  return (
    <>
      <div
        id="document-box"
        className="documents"
      >
        <PDFExport ref={pdfExportComponent} fileName={`เอกสารห้ามลงโปรแกรมละเมิดลิขสิทธิ์ - ${data.personal_info_name}`} forcePageBreak=".page-break">
          <div id="page1" style={{ fontFamily: "THSarabun" }}>
            <div>
              <img
                id="background"
                src={bg}
                alt="bg"
                style={{
                  width: "800px",
                  height: "auto",
                  position: "absolute",
                  top: "0%",
                  right: "0%",
                  zIndex: -5,
                  boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)"
                }}
              />
            </div>
            <div
              id="content"
              style={{
                zIndex: 2
              }}
            >
              <div
                id="formId"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "125px",
                  right: "65px",
                  border: "1px",
                  borderStyle: "solid",
                  padding: "8px",
                  paddingBottom: "0px",
                  paddingTop: "5px",
                  width: "70px",
                  fontSize: "16px",
                  letterSpacing: 0.14
                }}
              >
                <b className="docs-font">HRM-040</b>
              </div>
              <div
                id="date"
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "161px",
                  right: "47px",
                  fontSize: "16px",
                  width: "254px",
                  letterSpacing: 0.14,
                  textAlign: "justify"
                  // backgroundColor: "red"
                }}
              >
                วันที่...............เดือน...................................พ.ศ.
                ...................
              </div>

              <div
                id="set-tab-text"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "224.8px",
                  right: "47px",
                  fontSize: "16px",
                  // fontFamily: "angsaLight",
                  width: "658px",
                  letterSpaing: 0.14,
                  textAlign: "justify"
                }}
              >
                พนักงานทุกท่าน/ทุกหน้าร้าน
              </div>
              <div
                id="paragraph1"
                className="text-with-bold docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "204px",
                  right: "47px",
                  fontSize: "16px",
                  // fontFamily: "angsaLight",
                  width: "710px",
                  letterSpacing: 0.14,
                  textAlign: "justify",
                  lineHeight: "20.8px"
                }}
              >
                เรื่อง&emsp;&emsp;การห้ามลงโปรแกรม Software ต่างๆ
                ที่ผิดกฎหมายในผลิตภัณฑ์ที่นำมาจัดจำหน่าย
                <br />
                เรียน
                <br />
                <br />
                &nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;บริษัท คอมเซเว่น
                จำกัด (มหาชน) และ บริษัทในเครือ ซึ่งต่อไปเรียกว่า “บริษัท”
                ได้กำหนดนโยบายขึ้นดังนี้
                <br />
                &nbsp;&emsp;&emsp;&emsp;1.บริษัท มีนโยบาย ไม่รับลงโปรแกรม หรือ
                ซอฟแวร์ ตลอดจนไฟล์เพลงหรือภาพยนตร์
                แอปพลิเคชั่นที่ผิดกฎหมายต่าง ๆ และ/หรือ ไม่แนะนำ ไม่ชักชวน{" "}
                <u>
                  <b className="docs-font-bold">ให้ลูกค้า</b>
                </u>{" "}
                &nbsp;ลงโปรแกรมหรือซอฟแวร์ตลอดจนไฟล์เพลงหรือภาพยนตร์
                ที่ผิดกฎหมาย&nbsp;&nbsp;
                อันเป็นการละเมิดทรัพย์สินทางปัญญาและผิดกฏหมายลิขสิทธิ์ ทุกกรณี
                ไม่ว่าจะ อยู่ภายในร้าน หรือ นอกร้านของบริษัท หรือ
                ภายในสำนักงานใหญ่ หรือ ศูนย์บริการ หรือคลังสินค้า
                <br />
                &nbsp;&emsp;&emsp;&emsp;2.บริษัท ห้ามพนักงานแนะนำ ชักชวน
                ชี้แนะให้ลูกค้าไปลงโปรแกรม&nbsp;&nbsp; หรือ
                &nbsp;&nbsp;ซอฟแวร์ ตลอดจนไฟล์เพลงหรือภาพยนตร์
                แอปพลิเคชั่นที่ผิดกฎหมายต่าง ๆ ที่ผิดกฎหมาย&nbsp;&nbsp;
                อันเป็นการละเมิดทรัพย์สินทางปัญญาและผิดฏหมายลิขสิทธิ์&nbsp;&nbsp;
                ทุกกรณี&nbsp;&nbsp; ที่ร้านค้าอื่น&nbsp;&nbsp;
                หรือบูธอื่น&nbsp;&nbsp; หรือบุคคลอื่น ตลอดจนไม่ครอบครอง
                ไม่ทำซ้ำ ดัดแปลง จำหน่าย แจกจ่าย และ/หรือ มีไว้ใน ( Harddisk/
                CD/DVD /USB DRIVE / MEDIA CARD ) และ/หรือ
                สื่อบันทึกข้อมูลต่างๆภายในร้านไม่ว่ากรณีใดๆทั้งสิ้น
                <br />
                &nbsp;&emsp;&emsp;&emsp;3.บริษัท
                &nbsp;มีนโยบาย&nbsp;ส่งเสริมให้มี
                การแนะนำเพื่อขาย&nbsp;การจำหน่าย
                โปรแกรมหรือซอฟแวร์ที่ถูกต้องตามกฎหมายเท่านั้น{" "}
                <b className="docs-font-bold">
                  หากบริษัทพบว่าพนักงานท่านใด มีการทำผิดนโยบายข้อหนึ่งข้อใด
                  บริษัทจะลงโทษดังนี้
                </b>
                <br />
                &nbsp;&emsp;&emsp;&emsp;3.1.บริษัท
                ถือว่าพนักงานท่านนั้นกระทำความผิดนโยบายของบริษัทร้ายแรง
                บริษัทจะใช้บทลงโทษสูงสุดคือการให้พ้นสภาพการเป็นพนักงาน
                ของบริษัททันที
                รวมทั้งจะฟ้องร้องดำเนินคดีทั้งทางแพ่งและอาญาเพื่อดำเนินคดีให้ถึงที่สุด
                และเรียกค่าเสียหายต่างๆที่เกิดขึ้นกับพนักงานผู้ฝ่าฝืนทำการละเมิดนโยบายนี้อีกด้วย
                <br />
                &nbsp;&emsp;&emsp;&emsp;3.2.บริษัท จะไม่ให้การช่วยเหลือ
                (ไม่ว่าจะเป็นการขอประกันตัวชั้นพนักงานสอบสวน&nbsp;&nbsp;
                หรือชั้นศาลทั้งสิ้น&nbsp;&nbsp;หรือให้ทนายความของบริษัทเข้าช่วยเหลือใน
                ด้านกฎหมายอย่างเด็ดขาด)&nbsp;&nbsp; และ&nbsp;&nbsp;
                สงวนสิทธิ์ที่จะฟ้องร้องดำเนินคดีทั้งทางแพ่งและอาญากับพนักงานคนดังกล่าวเพื่อดำเนินคดีให้ถึงที่สุด
                และเรียกค่าเสียหายต่างๆที่
                เกิดขึ้นกับพนักงานผู้ฝ่าฝืนทำการละเมิดนโยบายนี้อีกด้วย
                <br />
                <br />
                &nbsp;&emsp;&emsp;&emsp;ทั้งนี้&nbsp;&nbsp;ถ้ามีบุคคลใด&nbsp;&nbsp;แอบอ้าง&nbsp;&nbsp;
                ว่าเป็นตัวแทนของบริษัท มาชักชวนให้ท่านทำผิดนโยบายนี้
                (แจ้งว่ามีข้อตกลงกับผู้บริหารของบริษัทในการรับลงโปรแกรม
                จากหน้าไว้แล้ว&nbsp;&nbsp;บริษัทขอยืนยันว่า&nbsp;&nbsp;
                บริษัทไม่มีนโยบายดังกล่าวและถือว่าเป็นการแอบอ้างอย่างสิ้นเชิง)&nbsp;&nbsp;
                หากพนักงานท่านใดพบเห็นเหตุการณ์ดังกล่าวให้รีบแจ้งมายัง
                ฝ่ายบุคคล (ต่อ 7203) และ/หรือฝ่ายกฎหมาย (ต่อ 7723) ของบริษัท
                <br />
                &nbsp;&emsp;&emsp;&emsp;จึงเรียนมาเพื่อทราบและขอให้พนักงานทุกท่านปฏิบัติตามอย่างเคร่งครัด
                <br />
                <br />
                <br />
                <br />
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;ลงชื่อ............................................................................
                <br />
                &nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;นายคงศักดิ์ บรรณาสถิตย์กุล
                <br />
                <br />
                &nbsp;&nbsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;       บริษัท {company.name_th}
                <br />
                <br />
                <br />
                <br />
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;ลงชื่อ.............................................................................พนักงานผู้รับทราบ
                <br />
                <br />
                &emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;&emsp;(
                ................................................................
                )
              </div>
            </div>
            <div id="var" className="var">
            {company2.head && (
                <img
                  src={company2.head}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "100px",
                    right: "10px",
                    top: "20px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              {company2.foot && (
                <img
                  src={company2.foot}
                  style={{
                    position: "absolute",
                    width: "770px",
                    height: "70px",
                    right: "10px",
                    top: "1060px",
                    zIndex: 100,
                    boxShadow: "0px 2px 38px rgba(0, 0, 0, 0.2)",
                  }}
                />
              )}
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "158px",
                  right: "241px",
                  fontSize: "16px",
                  width: "41px",
                  letterSpacing: 0.14,
                  textAlign: "center"
                  // backgroundColor: "red"
                }}
              >
                {data.date_day}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "158px",
                  right: "123px",
                  fontSize: "16px",
                  width: "94px",
                  letterSpacing: 0.14,
                  textAlign: "center"
                  // backgroundColor: "red"
                }}
              >
                {data.date_month}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "158px",
                  right: "47px",
                  fontSize: "16px",
                  width: "55px",
                  letterSpacing: 0.14,
                  textAlign: "center"
                  // backgroundColor: "red"
                }}
              >
                {data.date_year}
              </div>
              <div
                className="docs-font"
                style={{
                  zIndex: 2,
                  position: "absolute",
                  top: "909px",
                  right: "300px",
                  fontSize: "16px",
                  width: "178px",
                  letterSpacing: 0.14,
                  textAlign: "center"
                  // backgroundColor: "red"
                }}
              >
                {data.personal_info_name}
              </div>
              <img
                id="sign_inno"
                src={sign_inno}
                alt="sign_inno"
                style={{
                  height: '100px',
                  width: "178px",
                  position: "absolute",
                  top: "658px",
                  right: "260px",
                  zIndex: -5,
                }}
              />
            </div>
          </div>
        </PDFExport>
      </div>
    </>
  );
};

HRM_040.propTypes = {
  data: PropTypes.object.isRequired,
  pdfExportComponent: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.object })
  ])
};

export default HRM_040;
